// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"21407978","433":"77d81c26","579":"456a6a42","589":"413126b5","772":"38914aa2"}[chunkId] + ".chunk.js";
};